import React from "react";
import { DeleteProps } from "../types";
import ConfigModalLayout from "./ConfigModalLayout";

const DeleteConfigModal: React.FC<DeleteProps> = ({ open, onClose, onDelete, config }) => {
  const handleDelete = () => {
    if (config) {
      onDelete(config._id.$oid);
      onClose();
    }
  };

  return (
    <ConfigModalLayout
      open={open}
      onClose={onClose}
      title="Delete Configuration"
      confirmLabel="Delete"
      confirmVariant="primary"
      onConfirm={handleDelete}
    >
      <p>
        Are you sure you want to delete <strong>{config?.conname}</strong>?
      </p>
    </ConfigModalLayout>
  );
};

export default DeleteConfigModal;
